import React, { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import './Details.css';

const Details = () => {
    const [cartItems, setCartItems] = useState([]);
    const [checkoutStep, setCheckoutStep] = useState(1);
    const [address, setAddress] = useState('');
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('');

    const addToCart = (medicine) => {
        setCartItems([...cartItems, medicine]);
    };
  

    const removeFromCart = (itemId) => {
        const updatedCart = cartItems.filter(item => item.id !== itemId);
        setCartItems(updatedCart);
    };
    const calculateTotalPrice = () => {
        return cartItems.reduce((total, item) => total + parseFloat(item.price), 0).toFixed(2);
    };

    const handleCheckout = () => {
        setCheckoutStep(2);
    };


    const handleAddressSubmit = (e) => {
        e.preventDefault();
        setCheckoutStep(3);
    };
    /* eslint-disable no-undef */
    const medicines = [
        {
            id: 1,
            name: "Paracetamol",
            dosage: "500mg",
            description: "For pain relief and fever reduction",
            price: "5.99",
            image: "./medicineImg/paracetamol.avif"
        },
        {
            id: 2,
            name: "Ibuprofen",
            dosage: "200mg",
            description: "For pain relief and inflammation reduction",
            price: "7.99",
            image: "./path_to_ibuprofen_image.jpg"
        },
        {
            id: 3,
            name: "Aspirin",
            dosage: "81mg",
            description: "For pain relief and heart health",
            price: "4.99",
            image: "./path_to_aspirin_image.jpg"
        },
        {
            id: 4,
            name: "Amoxicillin",
            dosage: "500mg",
            description: "Antibiotic for bacterial infections",
            price: "9.99",
            image: "./path_to_amoxicillin_image.jpg"
        },
        {
            id: 5,
            name: "Omeprazole",
            dosage: "20mg",
            description: "For treating stomach ulcers and acid reflux",
            price: "20.99",
            image: "./path_to_omeprazole_image.jpg"
        },
        {
            id: 6,
            name: "ORS",
            dosage: "20g",
            description: "Glucose for instant energy",
            price: "10",
            image: "./path_to_omeprazole_image.jpg"
        }
    ];
    /* eslint-enable no-undef */
    return (
        <div>
            <section className="medicine-sec">
                <Container>
                    <h2 className="section-title">Available Medicines</h2>
                    <Row>
                        {medicines.map((medicine) => (
                            <Col key={medicine.id} md={4} sm={6} xs={12}>
                                <div className="medicine-card">
                                    {/* Display medicine image */}
                                    <img src={medicine.image} alt={medicine.name} className="medicine-img" />
                                    <div className="medicine-info">
                                        <h3 className="medicine-name">{medicine.name}</h3>
                                        <p className="medicine-price">$ {medicine.price}</p>
                                        <p className="medicine-description">{medicine.description}</p>
                                        <Button onClick={() => addToCart(medicine)} variant="primary">Add to Cart</Button>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section className="cart-sec">
                <Container>
                    <h2 className="section-title">Your Cart</h2>
                    <Row>
                        {cartItems.length === 0 ? (
                            <Col>
                                <p>Your cart is empty.</p>
                            </Col>
                        ) : (
                            <>
                                {cartItems.map((item) => (
                                    <Col key={item.id} md={6}>
                                        <div className="cart-item">
                                            <div className="item-details">
                                                <h3 className="item-name">{item.name}</h3>
                                                <p className="item-price">$ {item.price}</p>
                                            </div>
                                            <Button onClick={() => removeFromCart(item.id)} variant="danger">Remove</Button>
                                        </div>
                                    </Col>
                                ))}
                                <Col className="text-end">
                                    {checkoutStep === 1 && (
                                        <Button onClick={handleCheckout} variant="primary">Checkout</Button>
                                    )}
                                    {checkoutStep === 2 && (
                                        <Form onSubmit={handleAddressSubmit} className="checkout-form">
                                            <h2>Enter Your Address</h2>
                                            <Form.Group className="mb-3" controlId="formStreet">
                                                <Form.Label>Street</Form.Label>
                                                <Form.Control type="text" placeholder="Enter your street" value={street} onChange={(e) => setStreet(e.target.value)} />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="formCity">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control type="text" placeholder="Enter your city" value={city} onChange={(e) => setCity(e.target.value)} />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="formPostalCode">
                                                <Form.Label>Postal Code</Form.Label>
                                                <Form.Control type="text" placeholder="Enter your postal code" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="formCountry">
                                                <Form.Label>Country</Form.Label>
                                                <Form.Control type="text" placeholder="Enter your country" value={country} onChange={(e) => setCountry(e.target.value)} />
                                            </Form.Group>
                                            <Button type="submit" variant="primary">Next</Button>
                                        </Form>
                                    )}
                                    {checkoutStep === 3 && (
                                        <p>Order will be placed shortly.</p>
                                    )}
                                </Col>
                            </>
                        )}
                    </Row>
                    {checkoutStep !== 3 && (
                        <Row>
                            <Col className="text-end">
                                <p className="total-price">Total Price: $ {calculateTotalPrice()}</p>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>
        </div>
    );
};

export default Details;
